export class UnauthorizedError extends Error {
  public status: number = -1;
  private _isUnauthorizedError: boolean = true;

  constructor(status: number, message: string) {
    super(message);
    Object.setPrototypeOf(this, UnauthorizedError.prototype);

    this.status = status;
  }

  public get isUnauthorizedError() {
    return this._isUnauthorizedError;
  }

  public static isUnauthorizedError(
    error: UnauthorizedError | Error | unknown
  ): error is UnauthorizedError {
    return (error as UnauthorizedError).isUnauthorizedError;
  }
}
